
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/menoscale",
      function () {
        return require("private-next-pages/menoscale/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/menoscale"])
      });
    }
  